<script>
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  name: 'ChatQuickReplies',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // Namespace do store + chave do modal de gerenciar — default atendimento.
    // Solicitacoes injeta 'solicitacoes' + a sua chave MODAL disjunta.
    namespace: {
      type: String,
      default: 'atendimento',
    },
    manageModalKey: {
      type: String,
      default: MODAL.ATENDIMENTO_GERENCIAR_RESPOSTAS,
    },
  },
  data() {
    return {
      searchText: '',
    }
  },
  computed: {
    respostasRapidas() {
      return this.$store.getters[`${this.namespace}/respostasRapidas`]
    },
    filteredReplies() {
      const items = this.respostasRapidas || []
      if (!this.searchText) return items
      const query = this.searchText.toLowerCase()
      return items.filter((item) => {
        const titulo = (item.titulo || '').toLowerCase()
        const conteudo = (item.conteudo || '').toLowerCase()
        return titulo.includes(query) || conteudo.includes(query)
      })
    },
    hasReplies() {
      return this.filteredReplies.length > 0
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.searchText = ''
        this.$store.dispatch(`${this.namespace}/listarRespostasRapidas`)
      }
    },
  },
  methods: {
    selectReply(reply) {
      this.$emit('select', reply)
    },
    onGerenciar() {
      this.$emit('close')
      GlobalBus.$emit(this.manageModalKey)
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<template>
  <div
    v-if="visible"
    data-test="quick-replies-popup"
    class="quick-replies-popup px-4 py-2"
  >
    <div class="quick-replies-header d-flex align-center pa-2">
      <icon-svg
        name="mdi-lightning-bolt"
        size="16"
        color="primary"
        class="mr-2"
      />
      <span class="az-text-primary az-size-14 font-medium flex-grow-1">
        Respostas rápidas
      </span>
      <BaseButton
        primary
        small
        fit-content
        min-width="auto"
        data-test="gerenciar-btn"
        class="mr-1"
        @click="onGerenciar"
      >
        Gerenciar
      </BaseButton>
      <v-btn
        icon
        small
        data-test="quick-replies-close"
        aria-label="Fechar respostas rápidas"
        @click="onClose"
      >
        <icon-svg name="close" size="16" />
      </v-btn>
    </div>

    <div class="quick-replies-search pa-2">
      <input-by-type
        v-model="searchText"
        type="text"
        outlined
        dense
        hide-details
        data-test="quick-reply-search"
        placeholder="Buscar resposta..."
      />
    </div>

    <div class="quick-replies-list">
      <div
        v-for="reply in filteredReplies"
        :key="reply.id"
        data-test="quick-reply-item"
        class="quick-reply-item d-flex align-center pa-2"
        @click="selectReply(reply)"
      >
        <span
          class="az-text-primary az-size-14 font-medium mr-2 text-truncate quick-reply-item__titulo"
        >
          {{ reply.titulo }}
        </span>
        <span
          class="az-text-secondary az-size-12 text-truncate quick-reply-item__conteudo flex-grow-1"
        >
          {{ reply.conteudo }}
        </span>
      </div>

      <div
        v-if="!hasReplies"
        data-test="no-replies"
        class="az-text-secondary az-size-12 text-center pa-3"
      >
        Nenhuma resposta encontrada
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.quick-replies-popup
  position: absolute
  bottom: 100%
  left: 0
  right: 0
  max-height: 300px
  // Usa o mesmo bg da área de envio (flatGray/flatWhite via --panel-bg)
  // pra conectar visualmente com o input sem borda/divisor no bottom.
  background-color: var(--panel-bg)
  border-top: 1px solid var(--gray-3)
  border-radius: 8px 8px 0 0
  // z-index: 1 é suficiente pra cobrir mensagens (static) atrás.
  // Valor maior (ex: 10) cria stacking context que engole tooltips do
  // chat-input (v-tooltip content com z-index default).
  z-index: 1
  display: flex
  flex-direction: column

.quick-replies-header
  border-bottom: 1px solid var(--gray-f4)

.gerenciar-btn
  background: none
  border: none
  cursor: pointer
  padding: 4px 8px
  border-radius: 4px

  &:hover
    background-color: var(--gray-f4)

.quick-replies-search
  border-bottom: 1px solid var(--gray-f4)

.quick-replies-list
  overflow-y: auto
  max-height: 200px

.quick-reply-item
  cursor: pointer
  transition: background-color 0.15s ease
  border-bottom: 1px solid var(--gray-f4)

  &:hover
    background-color: var(--gray-f4)

  &:last-child
    border-bottom: none

// Truncate em flex children exige min-width: 0 (text-truncate do Vuetify 2
// não seta min-width por default). Título: até 40% da largura; conteúdo
// pega o resto com flex-grow e trunca ao estourar.
.quick-reply-item__titulo
  min-width: 0
  max-width: 40%

.quick-reply-item__conteudo
  min-width: 0
</style>
